export const CREATE_COST = 'createCost';
export const FETCH_COST_BY_ID = 'fetchCostById';
export const FETCH_PROJECT_COSTS = 'fetchProjectCosts';
export const UPDATE_COST_BY_ID = 'updateCostById';
export const DELETE_COST_BY_ID = 'deleteCostById';
